import { ArrowUpRight } from "lucide-react";
import CardServicos from "./cardServicos";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./carousel";
import Container from "./container";
import AccordionServicos from "./accordionServicos";
import BadgetOtimize from "./badget-otimize";
import { useState } from "react";

export default function MigracaoBeneficios({ servicosData, title }) {
  const { openModal } = useModal();
  const [openAccordionId, setOpenAccordionId] = useState(null);

  return (
    <div className="w-full bg-[rgb(24,14,81)] bg-[url(../assets/beneficios-finops-mobile.png)] md:bg-[url(../assets/cover-migracao-beneficios.png)] bg-cover bg-top py-20 relative overflow-hidden text-white">
      <Container className="relative z-10">
        <h2 className="font-inter-regular text-2xl md:text-[60px] text-center mb-12">
          {title}
        </h2>
        <div className="hidden md:block relative">
          <Carousel className="overflow-visible">
            <div className="flex justify-end absolute right-8 md:right-16 top-6 z-10">
              <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
              <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
            </div>
            <CarouselContent className="py-8">
              {servicosData.map((servico, index) => (
                <CarouselItem
                  key={index}
                  className="basis-full md:basis-1/2 lg:basis-1/3"
                >
                  <div className="relative overflow-visible">
                    <CardServicos
                      {...servico}
                      height={380}
                      className="w-full"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          <div className="relative py-[2px] px-px rounded-[30px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-fit">
            <div className="flex items-center gap-8 bg-[#2B283D] px-6 py-3.5 rounded-[30px] text-white w-[350px]">
              <h3 className="w-fit font-inter-light">
                Otimize seu <br /> negócio!
              </h3>
              <button
                type="button"
                onClick={() => openModal(<FormularioRD />)}
                className="w-fit bg-white text-black text-sm font-inter-light flex items-center m-auto gap-2 py-2 px-10 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
              >
                Contratar <ArrowUpRight className="size-5" />
              </button>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {servicosData.map((servico, index) => (
            <div key={index} className="space-y-4">
              <button
                type="button"
                onClick={() =>
                  setOpenAccordionId(
                    openAccordionId === servico.id ? null : servico.id,
                  )
                }
                className="w-full"
              >
                <AccordionServicos
                  {...servico}
                  className="bg-[rgb(36,29,73)] backdrop-blur-[92px]"
                  doesThereButton={false}
                />
              </button>

              {openAccordionId === servico.id && <BadgetOtimize />}
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
